import React, { useEffect, useState } from 'react';

import PropTypes from 'prop-types';

import { Row } from 'apps/auth/components/common/Layout/Row';
import { Text } from 'apps/auth/components/common/Text/Text';
import { resolveArguments } from 'apps/auth/helpers/utils';
import { usePageMessages } from 'apps/auth/hooks/selectors';

import Contact, { type as ContactType } from './Contact';
import Filter from './Filter';
import Import from './Import';

function useLocalSearch(defaultContacts, query) {
    const [contacts, setContacts] = useState(defaultContacts);

    useEffect(() => {
        const result = defaultContacts.filter((contact) => {
            const term = query.toLowerCase();
            return contact.fullName.toLowerCase().includes(term) || contact.phoneNum.includes(term);
        });
        setContacts(result);
    }, [query]);

    return contacts;
}

const renderAmount = (description) => (
    <Text variant="div" color="secondary">
        {description}
    </Text>
);

const List = (props) => {
    const { amountOfContacts } = usePageMessages();

    const [query, setSearch] = useState('');
    const contacts = useLocalSearch(props.contacts, query);

    const onChange = (e) => setSearch(e.target.value);

    return (
        <>
            <Row indent="adaptive-16-24">
                <Filter value={query} onChange={onChange} />
            </Row>
            <Import onSelect={props.onImport} />
            <Row indent="adaptive-24-32">
                {contacts.map((c, id) => (
                    <Contact
                        key={`keyContact${id}`}
                        fullName={c.fullName}
                        phoneNum={c.phoneNum}
                        avatarUrl={c.avatarUrl}
                        onClick={() => props.onClick(c.phoneNum)}
                    />
                ))}
            </Row>
            {contacts && contacts.length > 0 && renderAmount(resolveArguments(amountOfContacts, contacts.length))}
        </>
    );
};

List.propTypes = {
    contacts: PropTypes.arrayOf(PropTypes.shape(ContactType)),
    onClick: PropTypes.func,
};

export default List;
